import { FC, memo } from 'react';
import { Input, Select, Skeleton, DatePicker } from 'antd';
import dayjs from 'dayjs';
import cn from 'classnames';
import { roboCallTaskStateWeb } from '../../../models/enums/RoboCallTaskStateWeb';
import { MedVoxTask } from '../../../models/MedVox/MedVoxTask';
import { COLUMNS, RANGE_PRESENT } from './constants';
import { useMedVoxTasks } from '../../../hooks/components/useMedVoxTasks/useMedVoxTasks';
import { ClinicSelect } from '../../shared/ClinicSelect';
import { LoadingTable } from '../../shared/Loading';
import { TableResults } from '../../shared/TableResults';
import ExpandableRow from '../ExpandableRow/ExpandableRow';
import styles from './style.module.css';

export const { RangePicker } = DatePicker;

interface Props {
  showMedVox: boolean;
}

const MedVoxTasks: FC<Props> = ({ showMedVox }) => {
  const props = useMedVoxTasks();
  const clinicValue = props.taskRequest.clinicIds ?? [];
  const isTaskLoading = props.taskStatus.responseLoading;

  return (
    <>
      {props.clinicStatus.responseLoading ? (
        <Skeleton active />
      ) : (
        <form
          className={cn({
            [styles.form]: showMedVox,
            [styles.blockContainer]: showMedVox,
            [styles.invisible]: !showMedVox,
          })}
        >
          <RangePicker
            format={'DD.MM.YYYY'}
            className={cn(styles.input, styles.inputDate)}
            presets={RANGE_PRESENT}
            defaultValue={[dayjs(), dayjs()]}
            onChange={props.handleRangePicker}
            disabled={isTaskLoading}
          />

          <div className={styles.inputsContainer}>
            <Select
              className={cn(styles.input, styles.inputCall)}
              allowClear
              placeholder="Статус звонка"
              onChange={props.handleCallStatus}
              disabled={isTaskLoading}
            >
              {roboCallTaskStateWeb.map((state, index) => (
                <Select.Option key={index} value={state.value}>
                  {state.text}
                </Select.Option>
              ))}
            </Select>

            <Input
              className={cn(styles.input, styles.inputCall)}
              placeholder="Телефон"
              onChange={props.handlePhone}
              disabled={isTaskLoading}
            />
          </div>

          <div className={styles.inputsContainer}>
            <ClinicSelect
              clinics={props.clinics}
              className={cn(styles.input, styles.inputCampaign)}
              placeholder="Клиника"
              value={clinicValue}
              onChange={props.handleClinics}
              disabled={isTaskLoading}
            />
          </div>

          <TableResults
            isEmpty={
              props.currentTasks.length === 0 &&
              props.totalCount === 0 &&
              !props.taskStatus.responseError
            }
            loading={isTaskLoading}
          >
            <LoadingTable<MedVoxTask>
              columns={COLUMNS}
              className={styles.table}
              loading={isTaskLoading}
              pagination={{
                pageSize: props.pageSize,
                defaultCurrent: 1,
                responsive: true,
                total: props.totalCount,
                onChange: props.handleChange,
                current: props.taskRequest.pageNumber + 1,
                hideOnSinglePage: true,
                disabled: isTaskLoading,
              }}
              rowKey={(record) =>
                record.indexId !== undefined ? record.indexId : ''
              }
              showSorterTooltip={false}
              dataSource={props.currentTasks.map((task, index) => ({
                ...task,
                index,
              }))}
              expandable={{
                expandedRowRender: (record) => (
                  <ExpandableRow record={record} audioSrc={props.audioSrc} />
                ),
                expandedRowKeys: props.expandedRowKeys,
                onExpand: props.handleExpand,
              }}
            />
          </TableResults>
        </form>
      )}
    </>
  );
};

export default memo(MedVoxTasks);
